import React, { useEffect, useState } from "react";
import { FieldArray, Formik } from "formik";
import * as yup from "yup";
import { CustomArraySelectField } from "../../../../../partials/content/Forms";
import { onPreventEnterSubmitting } from "../../../../../utils/utils";
import { DialogActions } from "@material-ui/core";
import { Table } from "react-bootstrap";
import Illustration from "../../../../../partials/content/Illustration";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import { getSalesActivities } from "../../../../../services/setup/crm/crmSetupService";
import { FormArrayTextField } from "../../../../../partials/content/Forms/FormField";
function VisitActivities({ activities = [], onConfirmSave, onCloseDialog }) {
  const [salesActivities, setSalesActivities] = useState([]);
  const activitiesData = {
    data: activities,
  };
  const activitiesSchema = yup.object().shape({
    data: yup.array().of(
      yup.object().shape({
        ID: yup.number(),
        visitID: yup.number(),
        activityID: yup.number().min(1, "Activity is required"),
        comment: yup.string(),
      })
    ),
  });
  useEffect(() => {
    getSalesActivitiesData();
  }, []);
  return (
    <React.Fragment>
      <Formik
        initialValues={activitiesData}
        enableReinitialize={true}
        validateOnChange={false}
        validationSchema={activitiesSchema}
        onSubmit={async (values, { resetForm, setStatus, setSubmitting }) => {
          onConfirmSave(values.data);
        }}
      >
        {({
          dirty,
          values,
          status,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          isSubmitting,
        }) => (
          <React.Fragment>
            <form
              autoComplete="off"
              className="kt-form"
              onSubmit={handleSubmit}
              onKeyDown={onPreventEnterSubmitting}
            >
              <FieldArray name="data">
                {({ push, remove }) => (
                  <React.Fragment>
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <div className="card">
                          <Table borderless size="sm" responsive="xl">
                            {values.data && values.data.length > 0 ? (
                              <thead className="text-center">
                                <tr>
                                  <th style={{ width: "50%" }}>Activity</th>
                                  <th style={{ width: "45%" }}>Comment</th>
                                  <th>Actions</th>
                                </tr>
                              </thead>
                            ) : null}
                            <tbody>
                              {values.data && values.data.length > 0 ? (
                                values.data.map((activity, index) => (
                                  <tr key={index}>
                                    <td>
                                      <CustomArraySelectField
                                        arrayName="data"
                                        propertyName="activityID"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        index={index}
                                        value={values}
                                        touched={touched}
                                        errors={errors}
                                        options={salesActivities}
                                      />
                                    </td>
                                    <td>
                                      <FormArrayTextField
                                        arrayPropName="data"
                                        index={index}
                                        propName="comment"
                                        margin="none"
                                      />
                                    </td>
                                    <td
                                      style={{ whiteSpace: "nowrap" }}
                                      className="text-center"
                                    >
                                      <BootstrapTooltip title="Delete Activity Item">
                                        <button
                                          type="button"
                                          className="btn btn-icon btn-label-danger btn-md btn-circle mx-1"
                                          onClick={() => {
                                            remove(index);
                                          }}
                                        >
                                          <i className="fas fa-trash-alt"></i>
                                        </button>
                                      </BootstrapTooltip>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td className="text-center py-3" colSpan="3">
                                    <Illustration
                                      imageSource="INVIFO CRM.png"
                                      guidance="You don't have any Visit Activity items yet"
                                      guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                                      size="sm"
                                    ></Illustration>
                                  </td>
                                </tr>
                              )}
                              <tr>
                                <td className="text-center py-3" colSpan="3">
                                  <button
                                    type="button"
                                    className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
                                    onClick={() => {
                                      push({
                                        ID: 0,
                                        visitID: 0,
                                        activityID: 0,
                                        activityName: "",
                                        statusID: 1,
                                        comment: "",
                                      });
                                    }}
                                  >
                                    <i className="fas fa-plus-circle"></i>
                                    Add Activity
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                )}
              </FieldArray>
              <DialogActions>
                <button
                  type="button"
                  className="btn btn-label-danger btn-md btn-pill btn-bold"
                  onClick={onCloseDialog}
                >
                  <i className="fas fa-window-close"></i>
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-success btn-md btn-pill btn-bold"
                >
                  <i className="fas fa-save"></i>
                  Save
                </button>
              </DialogActions>
            </form>
          </React.Fragment>
        )}
      </Formik>
    </React.Fragment>
  );

  async function getSalesActivitiesData() {
    const salesActivities = [];
    const response = await getSalesActivities();
    const { data } = response.data;
    for (const activity of data.salesActivities) {
      salesActivities.push({
        label: activity.salesActivityName,
        value: activity.ID,
      });
    }
    setSalesActivities(salesActivities);
  }
}

export default VisitActivities;
